<template>
  <div class="access-denied" data-testid="access-denied">
    <el-result icon="warning" :title="$t(TEXT.title)" :sub-title="$t(TEXT.hint)">
      <template slot="extra">
        <p v-if="from" class="access-denied__path">{{ from }}</p>
        <el-button type="primary" size="medium" @click="goHome">{{ $t(TEXT.home) }}</el-button>
      </template>
    </el-result>
  </div>
</template>

<script>
import { ACCESS_DENIED_TEXT } from '@/utils/routeAccess'

/**
 * **권한 없는 화면 대신 여는 안내** (R-L P3-8 · R-K5 O-5). 라우터 가드(`utils/routeAccess`)가 세션 메뉴·액션에 없는 화면을
 * 여기로 보낸다 — 그 화면을 띄우면 첫 조회가 403 이고 이 앱의 403 은 세션을 끝낸다. 이 화면은 **요청을 하나도 부르지
 * 않는다**. 가려던 경로는 질의 `from` 으로 받아 보여 준다(질의 문자열은 가드가 싣지 않는다).
 */
export default {
  name: 'AccessDeniedView',
  data() {
    return { TEXT: ACCESS_DENIED_TEXT }
  },
  computed: {
    from() {
      const from = this.$route.query.from
      return typeof from === 'string' ? from : ''
    },
  },
  methods: {
    /** 역할 홈으로 — `MainView` 가 역할별로 보낸다 */
    goHome() {
      this.$router.push('/').catch(() => {})
    },
  },
}
</script>

<style scoped>
.access-denied {
  padding: 40px 16px;
}

.access-denied__path {
  margin: 0 0 16px;
  color: var(--color-text-secondary, #909399);
  font-family: monospace;
  word-break: break-all;
}
</style>
